import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  render() {
    if (this.state.error) return (
      <div style={{ minHeight:'100vh', background:'#0e1117', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:16, padding:24, fontFamily:"'Outfit',sans-serif" }}>
        <svg width="40" height="40" viewBox="0 0 64 64" fill="none">
          <path d="M10 48 L16 24 L28 36 L32 16 L36 36 L48 24 L54 48 Z" fill="#22c55e"/>
          <rect x="10" y="50" width="44" height="6" rx="3" fill="#22c55e"/>
        </svg>
        <div style={{ fontFamily:"'Playfair Display',serif", fontSize:22, fontWeight:900, color:'#fff' }}>
          Rent<span style={{color:'#22c55e'}}>Lord</span>
        </div>
        <div style={{ fontSize:13, color:'#f85149', background:'rgba(248,81,73,.08)', border:'1px solid rgba(248,81,73,.2)', borderRadius:10, padding:'14px 20px', maxWidth:480, textAlign:'center' }}>
          {this.state.error.toString()}
        </div>
        <button onClick={()=>window.location.reload()} style={{ padding:'10px 24px', borderRadius:8, background:'linear-gradient(135deg,#16a34a,#4ade80)', color:'#0a1a0a', border:'none', fontWeight:700, fontSize:14, cursor:'pointer' }}>
          Reload App
        </button>
      </div>
    );
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundary><App/></ErrorBoundary>);
